<template>
  <div style="height:100%;">
    <SimpleBar
      class="pe-2 me-n1 mb-3"
      :class="notesListData.length && 'upcoming-events'"
      data-simplebar="init"
      data-simplebar-track="primary"
      style="height: 100%; width: 250px; overflow: auto"
    >
      <div class="mb-3" v-for="(note, i) in notesListData" :key="i">
        <h6
          :style="{ borderLeft: `3px solid ${note.color}` }"
          class="card-title fs-16 ps-3"
        >
          {{ note.properties && note.properties.name }}
        </h6>
        <div class="ms-4 text-muted mb-2">
          {{this.$t('page.atlas-analysis.CreatedAt')}}{{ moment(note.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
        <div class="ms-3 text-muted fs-15">
          <div>{{ note.properties && note.properties.text }}</div>
        </div>
      </div>
    </SimpleBar>
  </div>
</template>
<script>
import { SimpleBar } from "simplebar-vue3";
import moment from "moment";
export default {
  props: {
    notesList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    moment,
    fn1(tempArr) {
      for (let i = 0; i < tempArr.length; i++) {
        for (let j = i + 1; j < tempArr.length; j++) {
          if (
            tempArr[i].properties &&
            tempArr[i].properties.time == tempArr[j].properties &&
            tempArr[j].properties.time
          ) {
            tempArr.splice(j, 1);
            j--;
          }
        }
      }
      return tempArr;
    },
   TimeRanges(DateStr,beginDateStr, endDateStr) {
        var curDate = new Date(DateStr),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
            return true;
        }
        return false;
    }
  },
  computed: {
    notesListData() {
      localStorage.removeItem('daterange')
      return this.notesList;
    },
  },
  components: {
    SimpleBar,
  },
};
</script>
